<template>
  <div style="z-index: 5000; position: fixed; top: 10px; right: 10px; width: 320px; display: flex; flex-direction: column;">
    <div v-if="Object.keys(display.CRMWhatsappNotificationDialogs).length > 1" style="width: 100%; display: flex; margin-bottom: 5px;">
      <v-card color="primary" class="control-card" elevation="10" rounded="lg" style="margin-left: auto; padding: 10px; display: flex; justify-content: space-between;">
        <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
          <v-icon @click="Object.values(display.CRMWhatsappNotificationDialogs).forEach(CRMWhatsappNotificationDialog => CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogPinned = !CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogPinned)" size="x-small" class="hoverableElement">{{ Object.values(display.CRMWhatsappNotificationDialogs).every(CRMWhatsappNotificationDialog => CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogPinned) ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
          <v-icon @click="this.display.CRMWhatsappNotificationDialogs = {}" size="x-small" class="hoverableElement">mdi-close-circle</v-icon>
        </div>
      </v-card>
    </div>
    <transition-group name="notificationTransition">
      <v-card v-for="(CRMWhatsappNotificationDialog, CRMWhatsappNotificationDialogKey) in display.CRMWhatsappNotificationDialogs" v-bind:key="CRMWhatsappNotificationDialogKey" @mouseenter="pauseCRMWhatsappNotificationDialogTimer(CRMWhatsappNotificationDialogKey)" @mouseleave="resumeCRMWhatsappNotificationDialogTimer(CRMWhatsappNotificationDialogKey)" :disabled="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyLoader" color="primary" elevation="10" rounded="lg" style="margin-bottom: 5px; padding: 10px; user-select: none;">
        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
          <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
            <v-icon @click="$generalFunctions.default.navigateTo(`/chat?CRMWhatsappConversationID=${CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCRMWhatsappConversationID}`)" class="hoverableElement">
              mdi-whatsapp
            </v-icon>
            <div style="display: flex; flex-direction: column; justify-content: center;">
              <p style="margin: 0; font-weight: 600; font-size: 0.95rem;">{{ CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCRMWhatsappContactName }}</p>
              <p style="margin: 0; font-size: 0.75rem; color: rgba(255, 255, 255, 0.7);">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCRMWhatsappConversationPhoneNumber, false) }}</p>
              <p v-if="CRMWhatsappNotificationDialog.CRMWhatsappMessages.length == 1 || !CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCollapsed" style="margin: 0; font-size: 0.85rem; margin-top: 2px; color: rgba(255, 255, 255, 0.9);">
                <span v-if="CRMWhatsappNotificationDialog.CRMWhatsappMessages.length == 1 && CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType == 'text'" style="">{{ CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent.length > 100 ? CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent.substring(0, 100) + '...' : CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent }}</span>
                <span v-else-if="CRMWhatsappNotificationDialog.CRMWhatsappMessages.length == 1 && CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType != 'text'">{{ {'media': 'Mensaje multimedia', 'contacts': 'Mensaje de contacto', 'location': 'Mensaje de ubicación', 'unsupported': 'Mensaje no soportado'}[CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType] }}</span>
                <span v-else>{{ CRMWhatsappNotificationDialog.CRMWhatsappMessages.length }} mensajes</span>
              </p>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
            <v-icon v-if="CRMWhatsappNotificationDialog.CRMWhatsappMessages.length > 1" @click="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCollapsed = !CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCollapsed" size="small" class="hoverableElement">{{ CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCollapsed ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            <v-icon @click="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReply = (CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID ? true : !CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReply); CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID = null; CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText = null;" size="small" class="hoverableElement">mdi-reply</v-icon>
            <v-icon @click="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogPinned = !CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogPinned" size="small" class="hoverableElement">{{ CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogPinned ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
            <v-icon @click="CRMWhatsappNotificationDialog.CRMWhatsappMessages.length == 1 ? discardCRMWhatsappMessageNotificationDialog(CRMWhatsappNotificationDialogKey, CRMWhatsappNotificationDialog.CRMWhatsappMessages[0].CRMWhatsappMessageNotificationDialogID) : discardCRMWhatsappNotificationDialog(CRMWhatsappNotificationDialogKey)" size="small" class="hoverableElement">mdi-close-circle</v-icon>
          </div>
        </div>
        <transition name="CRMWhatsappNotificationDialogMessages">
          <div v-if="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogCollapsed && CRMWhatsappNotificationDialog.CRMWhatsappMessages.length > 1">
            <v-card color="messageContainer" rounded="lg" style="display: flex; flex-direction: column; gap: 5px; max-height: 300px; overflow-y: auto; margin-top: 10px; padding: 5px; scrollbar-width: none; -ms-overflow-style: none;">
              <div v-for="CRMWhatsappMessage in CRMWhatsappNotificationDialog.CRMWhatsappMessages" v-bind:key="CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogID">
                <transition name="CRMWhatsappMessageNotificationDialogMessage">
                  <v-card v-if="!CRMWhatsappMessage.isRemoving" color="messageBg" rounded="lg" style="position: relative;">
                    <div style="position: absolute; top: 4px; right: 4px; display: flex; gap: 4px;">
                      <v-icon v-if="CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType == 'text'" @click="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReply = (CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID == CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID ? false : true); CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID = (CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID == CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID ? null : CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID); CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText = null;" size="x-small" class="hoverableElement" style="opacity: 0.6;">mdi-reply</v-icon>
                      <v-icon @click="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReply = CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID == CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID ? false : CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReply; CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID = CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID == CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID ? null : CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID; discardCRMWhatsappMessageNotificationDialog(CRMWhatsappNotificationDialogKey, CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogID)" size="x-small" class="hoverableElement" style="opacity: 0.6;">mdi-close-circle</v-icon>
                    </div>
                    <div style="padding: 8px 12px; padding-right: 60px;">
                      <p v-if="CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType == 'text'" style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText));">{{ CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent }}</p>
                      <div v-else>
                        <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText));">{{ {'media': 'Mensaje multimedia', 'contacts': 'Mensaje de contacto', 'location': 'Mensaje de ubicación', 'unsupported': 'Mensaje no soportado'}[CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType] }}</p>
                        <p style="margin: 0; font-size: 0.65rem; color: rgb(var(--v-theme-messageTime));">Abre la conversación para ver el mensaje</p>
                      </div>
                      <p style="margin: 0; font-size: 0.65rem; color: rgb(var(--v-theme-messageTime));">{{ $displayFunctions.default.fromDatetimeToHHMM(CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageDateTime) }}</p>
                    </div>
                  </v-card>
                </transition>
              </div>
            </v-card>
          </div>
        </transition>
        <transition name="replyCRMWhatsappMessage">
          <div v-if="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReply" style="margin-top: 10px;">
            <v-textarea 
              class="custom-textarea"
              v-model="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText"
              variant="outlined"
              auto-grow
              hide-details
              autofocus
              rows="2"
              autocomplete="off"
              :label="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID ? `Respondiendo a: ${CRMWhatsappNotificationDialog.CRMWhatsappMessages.find(CRMWhatsappMessage => CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID == CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID).CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent}` : ''"
              :append-inner-icon="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText && /\S/.test(CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText) ? 'mdi-send' : 'mdi-close'"
              @keydown="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText && /\S/.test(CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText) ? handleCRMWhatsappNotificationDialogReplyTextKeydown(CRMWhatsappNotificationDialogKey) : null"
              @click:append-inner="CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText && /\S/.test(CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText) ? sendCRMWhatsappTextMessageFromNotificationDialog(CRMWhatsappNotificationDialogKey) : CRMWhatsappNotificationDialog.CRMWhatsappNotificationDialogReplyText = null"
            ></v-textarea>
          </div>
        </transition>
      </v-card>


      <v-card v-for="(CRMWhatsappConversationFeedbackDialog, CRMWhatsappConversationFeedbackDialogKey) in display.CRMWhatsappConversationFeedbackDialogs" v-bind:key="CRMWhatsappConversationFeedbackDialogKey" @mouseenter="pauseCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackDialogKey)" @mouseleave="resumeCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackDialogKey)" color="secondary" elevation="10" rounded="lg" style="margin-bottom: 5px; padding: 10px; user-select: none;">
        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
          <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
            <v-icon>mdi-star-shooting</v-icon>
            <div style="display: flex; flex-direction: column; justify-content: center;">
              <p style="margin: 0; font-weight: 600; font-size: 0.95rem;">{{ CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMContactName }}</p>
              <p style="margin: 0; font-size: 0.75rem; color: rgba(255, 255, 255, 0.7);">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMContactPhoneNumber, false) }}</p>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
            <v-icon @click="CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogPinned = !CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogPinned" size="small" class="hoverableElement">{{ CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogPinned ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
            <v-icon @click="discardCRMWhatsappConversationFeedbackDialog(CRMWhatsappConversationFeedbackDialogKey)" size="small" class="hoverableElement">mdi-close-circle</v-icon>
          </div>
        </div>
        <div style="margin-top: 10px; display: flex; align-items: center;">
          <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText)); font-weight: bold; margin-right: 10px; line-height: 1;">Atención:</p>
          <div style="display: flex; align-items: center; transform: translateY(-1px);">
            <v-icon v-for="i in CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackOne" :key="i" size="small" class="hoverableElement">mdi-star</v-icon>
          </div>
        </div>
        <div style="margin-top: 10px; display: flex; align-items: center;">
          <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText)); font-weight: bold; margin-right: 10px; line-height: 1;">Velocidad:</p>
          <div style="display: flex; align-items: center; transform: translateY(-1px);">
            <v-icon v-for="i in CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackTwo" :key="i" size="small" class="hoverableElement">mdi-star</v-icon>
          </div>
        </div>
        <div style="margin-top: 10px; display: flex; align-items: center;">
          <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText)); font-weight: bold; margin-right: 10px; line-height: 1;">Productos:</p>
          <div style="display: flex; align-items: center; transform: translateY(-1px);">
            <v-icon v-for="i in CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackThree" :key="i" size="small" class="hoverableElement">mdi-star</v-icon>
          </div>
        </div>
        <div style="margin-top: 10px; display: flex; align-items: center;">
          <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText)); font-weight: bold; margin-right: 10px; line-height: 1;">Recomendación:</p>
          <div style="display: flex; align-items: center; transform: translateY(-1px);">
            <v-icon v-for="i in CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackFour" :key="i" size="small" class="hoverableElement">mdi-star</v-icon>
          </div>
        </div>
        <div style="margin-top: 10px; display: flex; align-items: center;">
          <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText)); font-weight: bold; margin-right: 10px; line-height: 1;">Total:</p>
          <div style="display: flex; align-items: center; transform: translateY(-1px);">
            <v-icon v-for="i in Math.round((CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackOne + CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackTwo + CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackThree + CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackFour) / 4)" :key="i" size="small" class="hoverableElement">mdi-star</v-icon>
          </div>
        </div>
        <div style="margin-top: 10px; max-height: 150px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
          <p style="margin: 0; font-size: 0.85rem; color: rgb(var(--v-theme-messageText)); font-style: italic;">"{{ CRMWhatsappConversationFeedbackDialog.CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackSix }}"</p>
        </div>
      </v-card>


      <v-card v-for="(systemNotificationDialog, systemNotificationDialogKey) in display.systemNotificationDialogs" v-bind:key="systemNotificationDialogKey" @mouseenter="pauseSystemNotificationDialogTimer(systemNotificationDialogKey)" @mouseleave="resumeSystemNotificationDialogTimer(systemNotificationDialogKey)" :color="{'error': 'error', 'success': 'success', 'warning': 'warning', 'info': 'teal', 'CRMWhatsappConversationTransfer': 'primary'}[systemNotificationDialog.systemNotificationDialogType]" elevation="10" rounded="lg" class="hoverableText" style="margin-bottom: 5px; padding: 10px; user-select: none;">
        <div v-if="systemNotificationDialog.systemNotificationDialogType == 'CRMWhatsappConversationTransfer'">
          <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
              <v-chip :color="systemNotificationDialog.systemNotificationDialogData.sourceCRMAgentColor" variant="flat" style="cursor: default; user-select: none;">
                <div style="display: flex; align-items: center;">
                  <img :src="systemNotificationDialog.systemNotificationDialogData.sourceCRMAgentProfilePictureURL" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                  <p :style="{ color: systemNotificationDialog.systemNotificationDialogData.sourceCRMAgentFontColor, margin: 0}">{{ systemNotificationDialog.systemNotificationDialogData.sourceCRMAgentName }}</p>
                </div>
              </v-chip>
              <p v-if="systemNotificationDialog.systemNotificationDialogOccurrences > 1 || systemNotificationDialog.systemNotificationDialogTriggerPlusOneAnimation" style="font-size: 0.85rem;">
                ({{ systemNotificationDialog.systemNotificationDialogOccurrences }})
                <span v-if="systemNotificationDialog.systemNotificationDialogTriggerPlusOneAnimation" class="plus-one">+1</span>
              </p>
            </div>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 5px; margin-left: auto;">
              <v-icon @click="systemNotificationDialog.systemNotificationDialogPinned = !systemNotificationDialog.systemNotificationDialogPinned; resetSystemNotificationDialogTimer(systemNotificationDialogKey)" size="small" class="hoverableElement">{{ systemNotificationDialog.systemNotificationDialogPinned ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
              <v-icon @click="discardNotificationDialog(systemNotificationDialogKey)" class="hoverableElement" dark>mdi-close-circle</v-icon>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 5px; margin-top: 10px;">
            <v-icon size="small">mdi-phone</v-icon>
            <p style="margin: 0; font-size: small;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(systemNotificationDialog.systemNotificationDialogData.CRMWhatsappConversationPhoneNumber, false) }}</p>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
            <v-icon size="small">mdi-account</v-icon>
            <p style="margin: 0; font-size: small;">{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(systemNotificationDialog.systemNotificationDialogData) }}</p>
          </div>
          <div style="display: flex; margin-top: 10px; width: 100%; gap: 10px;">
            <div style="width: 50%;">
              <v-btn @click="acceptCRMWhatsappConversationTransfer(systemNotificationDialogKey)" block color="success" variant="flat" size="small" style="font-weight: bold;"><v-icon size="small" style="margin-right: 5px;">mdi-check-circle</v-icon> ACEPTAR</v-btn>
            </div>
            <div style="width: 50%;">
              <v-btn @click="rejectCRMWhatsappConversationTransfer(systemNotificationDialogKey)" block color="error" variant="flat" size="small" style="font-weight: bold;"><v-icon size="small" style="margin-right: 5px;">mdi-close-circle</v-icon> RECHAZAR</v-btn>
            </div>
          </div>
        </div>
        
        <div v-else :style="systemNotificationDialog.systemNotificationDialogType == 'info' ? 'position: relative;' : ''">
          <div :style="systemNotificationDialog.systemNotificationDialogType == 'info' ? 'display: flex; flex-direction: row; align-items: center; gap: 5px; position: absolute; top: 0; right: 0;' : 'display: flex; flex-direction: row; align-items: center; justify-content: space-between;'">
            <div v-if="systemNotificationDialog.systemNotificationDialogType != 'info'" style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
              <v-icon @click="systemNotificationDialog.systemNotificationDialogType == 'error' ? $generalFunctions.default.copyToClipboard(this, 'Error de sistema', 'o', systemNotificationDialog.systemNotificationDialogID) : null" :class="systemNotificationDialog.systemNotificationDialogType == 'error' ? 'hoverableElement' : ''">{{ {'error': 'mdi-alert-circle', 'success': 'mdi-check-circle', 'warning': 'mdi-alert'}[systemNotificationDialog.systemNotificationDialogType] }}</v-icon>
              <p><strong>{{ {'error': 'ERROR', 'success': 'ÉXITO', 'warning': 'ATENCIÓN'}[systemNotificationDialog.systemNotificationDialogType] }}</strong></p>
              <p v-if="systemNotificationDialog.systemNotificationDialogOccurrences > 1 || systemNotificationDialog.systemNotificationDialogTriggerPlusOneAnimation" style="font-size: 0.85rem;">
                ({{ systemNotificationDialog.systemNotificationDialogOccurrences }})
                <span v-if="systemNotificationDialog.systemNotificationDialogTriggerPlusOneAnimation" class="plus-one">+1</span>
              </p>
            </div>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 5px; margin-left: auto;">
              <v-icon @click="systemNotificationDialog.systemNotificationDialogPinned = !systemNotificationDialog.systemNotificationDialogPinned; resetSystemNotificationDialogTimer(systemNotificationDialogKey)" size="small" class="hoverableElement">{{ systemNotificationDialog.systemNotificationDialogPinned ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
              <v-icon @click="discardNotificationDialog(systemNotificationDialogKey)" class="hoverableElement" dark>mdi-close-circle</v-icon>
            </div>
          </div>
          <p :style="systemNotificationDialog.systemNotificationDialogType == 'info' ? 'margin: 0; font-size: 0.85rem; padding-right: 70px;' : 'margin-top: 5px; font-size: 0.85rem;'">{{ systemNotificationDialog.systemNotificationDialogBody }}</p>
        </div>
      </v-card>

      <v-card 
        v-for="(CRMRealTimeEvent, CRMRealTimeEventKey) in display.CRMRealTimeEvents" 
        v-bind:key="CRMRealTimeEventKey" 
        @mouseenter="pauseCRMRealTimeEventTimer(CRMRealTimeEventKey)" 
        @mouseleave="resumeCRMRealTimeEventTimer(CRMRealTimeEventKey)" 
        color="primary" 
        elevation="10" 
        rounded="lg" 
        width="250px"
        class="hoverableText" 
        style="margin-bottom: 5px; padding: 10px; user-select: none; margin-left: auto; display: flex; flex-direction: column; gap: 5px;"
      >
        <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
          <v-icon size="x-small" color="indigo">{{ {'closeCRMWhatsappConversation': 'mdi-chat-remove', 'generateCRMWhatsappInvoice': 'mdi-invoice-text-plus', 'cancelCRMWhatsappInvoice': 'mdi-invoice-text-remove', 'confirmSINPEPayment': 'mdi-cash-check'}[CRMRealTimeEvent.CRMRealTimeEventType] }}</v-icon>
          <p style="font-size: small;"><strong>{{ {'closeCRMWhatsappConversation': 'Cierre de conversación', 'generateCRMWhatsappInvoice': 'Generación de orden', 'cancelCRMWhatsappInvoice': 'Cancelación de orden', 'confirmSINPEPayment': 'Confirmación de SINPE'}[CRMRealTimeEvent.CRMRealTimeEventType] }}</strong></p>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 5px; margin-left: auto;">
            <v-icon @click="CRMRealTimeEvent.CRMRealTimeEventPinned = !CRMRealTimeEvent.CRMRealTimeEventPinned; resetCRMRealTimeEventTimer(CRMRealTimeEventKey)" size="x-small" class="hoverableElement">{{ CRMRealTimeEvent.CRMRealTimeEventPinned ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
            <v-icon @click="discardCRMRealTimeEvent(CRMRealTimeEventKey)" size="x-small" class="hoverableElement">mdi-close-circle</v-icon>
          </div>
        </div>
        <template v-if="CRMRealTimeEvent.CRMRealTimeEventType == 'closeCRMWhatsappConversation'">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
              <div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-barcode</v-icon>
                  <p style="font-size: x-small;">{{ CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationID }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-timeline</v-icon>
                  <p style="font-size: x-small;">{{ CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationResult }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-clock</v-icon>
                  <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSS(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationEndDatetime) }}</p>
                </div>
              </div>
              <v-template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" size="x-small" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 15px; height: 15px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p style="font-size: x-small;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </v-template>
              <v-template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <p style="font-size: x-small;">No registrado</p>
                </v-chip>
              </v-template>
            </div>
            <v-btn 
              @click="$root.dialogComponent.openCRMWhatsappConversationDialog(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
              block
              color="indigo" 
              density="compact"
              class="hoverableText"
            >
              <v-icon size="x-small" style="margin-right: 10px;">mdi-chat</v-icon>
              <p style="font-size: x-small;">VER CONVERSACIÓN</p>
            </v-btn>
          </div>
        </template>

        <template v-if="CRMRealTimeEvent.CRMRealTimeEventType == 'generateCRMWhatsappInvoice'">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
              <div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-barcode</v-icon>
                  <p style="font-size: x-small;">{{ CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-cash</v-icon>
                  <p style="font-size: x-small;">₡{{ $displayFunctions.default.parseAmountToDisplay(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceAmount) }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-clock</v-icon>
                  <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSS(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCreationDatetime) }}</p>
                </div>
              </div>
              <div style="margin-left: auto; display: flex; flex-direction: column; align-items: center; gap: 5px;">
                <v-template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCreationCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" size="x-small" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 15px; height: 15px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p style="font-size: x-small;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </v-template>
                <v-template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <p style="font-size: x-small;">No registrado</p>
                  </v-chip>
                </v-template>
                <template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID)">
                  <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" size="x-small" label>
                    <p style="font-size: x-small;">{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" size="x-small" label>
                    <p style="font-size: x-small;">No registrada</p>
                  </v-chip>
                </template>
              </div>
            </div>
            <v-btn 
              @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceID])" 
              block
              color="indigo" 
              density="compact"
              class="hoverableText"
            >
              <v-icon size="x-small" style="margin-right: 10px;">mdi-invoice-text</v-icon>
              <p style="font-size: x-small;">VER ORDEN</p>
            </v-btn>
            <v-btn 
              @click="$root.dialogComponent.openCRMWhatsappConversationDialog(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceCRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
              block
              color="indigo" 
              density="compact"
              class="hoverableText"
            >
              <v-icon size="x-small" style="margin-right: 10px;">mdi-chat</v-icon>
              <p style="font-size: x-small;">VER CONVERSACIÓN</p>
            </v-btn>
          </div>
        </template>

        <template v-if="CRMRealTimeEvent.CRMRealTimeEventType == 'cancelCRMWhatsappInvoice'">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
              <div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-barcode</v-icon>
                  <p style="font-size: x-small;">{{ CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-clock</v-icon>
                  <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSS(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceUpdateDatetime) }}</p>
                </div>
              </div>
              <v-template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceUpdateCRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceUpdateCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" size="x-small" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceUpdateCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 15px; height: 15px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p style="font-size: x-small;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceUpdateCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </v-template>
              <v-template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <p style="font-size: x-small;">No registrado</p>
                </v-chip>
              </v-template>
            </div>
            <v-btn 
              @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceID])" 
              block
              color="indigo" 
              density="compact"
              class="hoverableText"
            >
              <v-icon size="x-small" style="margin-right: 10px;">mdi-invoice-text</v-icon>
              <p style="font-size: x-small;">VER ORDEN</p>
            </v-btn>
          </div>
        </template>

        <template v-if="CRMRealTimeEvent.CRMRealTimeEventType == 'confirmSINPEPayment'">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
              <div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-barcode</v-icon>
                  <p style="font-size: x-small;">{{ CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationID || CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-cash</v-icon>
                  <p style="font-size: x-small;">₡{{ $displayFunctions.default.parseAmountToDisplay(CRMRealTimeEvent.CRMRealTimeEventData.SINPEPaymentAmount) }}</p>
                </div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                  <v-icon size="xx-small" color="indigo">mdi-clock</v-icon>
                  <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSS(CRMRealTimeEvent.CRMRealTimeEventData.SINPEPaymentDatetime) }}</p>
                </div>
              </div>
              <v-template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.SINPEPaymentCRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.SINPEPaymentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" size="x-small" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.SINPEPaymentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 15px; height: 15px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p style="font-size: x-small;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMRealTimeEvent.CRMRealTimeEventData.SINPEPaymentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </v-template>
              <v-template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <p style="font-size: x-small;">No registrado</p>
                </v-chip>
              </v-template>
            </div>
            <template v-if="CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationID">
              <v-btn 
                @click="$root.dialogComponent.openCRMWhatsappConversationDialog(CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
                block
                color="indigo" 
                density="compact"
                class="hoverableText"
              >
                <v-icon size="x-small" style="margin-right: 10px;">mdi-chat</v-icon>
                <p style="font-size: x-small;">VER CONVERSACIÓN</p>
              </v-btn>
              </template>
              <template v-else>
                <v-btn 
                @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([CRMRealTimeEvent.CRMRealTimeEventData.CRMWhatsappInvoiceID])" 
                block
                color="indigo" 
                density="compact"
                class="hoverableText"
              >
                <v-icon size="x-small" style="margin-right: 10px;">mdi-invoice-text</v-icon>
                <p style="font-size: x-small;">VER ORDEN</p>
              </v-btn>
            </template>
          </div>
        </template>

        
      </v-card>

    </transition-group>
  </div>
</template>

<style scoped>
::v-deep(.custom-textarea .v-field__input) {
  font-size: 0.8rem !important;
}

  .notificationTransition-enter-active {
    animation: slideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .notificationTransition-leave-active {
    animation: slideOut 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%) scale(0.95);
      opacity: 0;
    }
    to {
      transform: translateX(0) scale(1);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0) scale(1);
      opacity: 1;
    }
    to {
      transform: translateX(100%) scale(0.95);
      opacity: 0;
    }
  }

  .CRMWhatsappMessageNotificationDialogMessage-enter-active,
  .CRMWhatsappMessageNotificationDialogMessage-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 100px;
    opacity: 1;
    transform: translateY(0);
  }

  .CRMWhatsappMessageNotificationDialogMessage-enter-from,
  .CRMWhatsappMessageNotificationDialogMessage-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
    margin-top: 0;
  }

  /* Add smooth transition for the chevron icon */
  .hoverableElement {
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .hoverableElement:hover {
    transform: scale(1.1);
  }

  /* Add highlight animation for message count */
  .message-count {
    display: inline-block;
    animation: highlightCount 0.5s ease-out;
  }

  @keyframes highlightCount {
    0% {
      transform: scale(1);
      font-weight: 400;
    }
    50% {
      transform: scale(1.2);
      font-weight: 600;
    }
    100% {
      transform: scale(1);
      font-weight: 400;
    }
  }

  /* Add fade-in animation for chevron appearance */
  .mdi-chevron-up,
  .mdi-chevron-down {
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  .replyCRMWhatsappMessage-enter-active,
  .replyCRMWhatsappMessage-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 60px;
    opacity: 1;
    transform: translateY(0);
  }

  .replyCRMWhatsappMessage-enter-from,
  .replyCRMWhatsappMessage-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
    margin-top: 0;
  }

  .control-card {
    animation: slideInControl 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes slideInControl {
    from {
      transform: translateX(50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .plus-one {
    display: inline-block;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.9);
    animation: plusOneAnimation 1s ease-in-out;
    animation-iteration-count: 1;
  }

  @keyframes plusOneAnimation {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }
    20% {
      transform: scale(1.2);
      opacity: 1;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
    80% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
</style>

<script>
import {systemInformation} from '@/utilities/systemInformation';

export default {

  inject: ['$generalFunctions', '$displayFunctions'],

  data: () => ({
    display: 
    {
      CRMWhatsappNotificationDialogs: {},
      CRMWhatsappConversationFeedbackDialogs: {},
      systemNotificationDialogs: {},
      CRMRealTimeEvents: {}
    },

    navigation:
    {
      CRMWhatsappNotificationDialogTimers: {},
      CRMWhatsappConversationFeedbackDialogTimers: {},
      hoveredCRMWhatsappNotificationDialogs: new Set(),
      hoveredCRMWhatsappConversationFeedbackDialogs: new Set(),
      hoveredSystemNotificationDialogs: new Set(),
      hoveredCRMRealTimeEvents: new Set()
    },
    
    systemInformationData: 
    {
      CRMAccountID: null,
      CRMAgentID: null,
      CRMAgents: [],
      CRMLocalities: [],
      tooltipDisabled: false,
      volumeLevel: 0,
      updateSubscription: null
    },
  }),

  

  methods: {

  
    async sendCRMWhatsappTextMessageFromNotificationDialog(CRMWhatsappMessageNotificationDialogKey) {
      const CRMWhatsappMessageNotificationDialog = this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogKey];
      if (CRMWhatsappMessageNotificationDialog) {
        CRMWhatsappMessageNotificationDialog.CRMWhatsappNotificationDialogReplyLoader = true;
        const CRMWhatsappMessage = CRMWhatsappMessageNotificationDialog.CRMWhatsappMessages.find(CRMWhatsappMessage => CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID == CRMWhatsappMessageNotificationDialog.CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID);
        const sendCRMWhatsappTextMessageFromNotificationDialogRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappConversationID': CRMWhatsappMessageNotificationDialog.CRMWhatsappNotificationDialogCRMWhatsappConversationID,
          'CRMWhatsappConversationPhoneNumber': CRMWhatsappMessageNotificationDialog.CRMWhatsappNotificationDialogCRMWhatsappConversationPhoneNumber,
          'CRMWhatsappMessageContextCRMWhatsappMessageID': CRMWhatsappMessage ? CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID : null,
          'CRMWhatsappMessageContextCRMWhatsappMessageAPIID': CRMWhatsappMessage ? CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageAPIID : null,
          'CRMWhatsappTextMessageContent': CRMWhatsappMessageNotificationDialog.CRMWhatsappNotificationDialogReplyText,
          'CRMWhatsappMessageTemporalID': null
        };
        const sendCRMWhatsappTextMessageFromNotificationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMessage/functions/sendCRMWhatsappTextMessageFromWhatsappConversationComponent', sendCRMWhatsappTextMessageFromNotificationDialogRequestQuery);
        if (sendCRMWhatsappTextMessageFromNotificationDialogResult.success) {
          this.discardCRMWhatsappNotificationDialog(CRMWhatsappMessageNotificationDialogKey);
        } else {
          this.showSystemNotificationDialog('sendCRMWhatsappTextMessageFromNotificationDialog_error', 'error', 'Ha ocurrido un error inesperado al enviar el mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          CRMWhatsappMessageNotificationDialog.CRMWhatsappNotificationDialogReplyLoader = false;
        }
      }
    },
    
    handleCRMWhatsappNotificationDialogReplyTextKeydown(CRMWhatsappNotificationDialogKey){
      if (event.key == 'Enter' && !event.shiftKey){
        event.preventDefault();
        this.sendCRMWhatsappTextMessageFromNotificationDialog(CRMWhatsappNotificationDialogKey);
      }
    },

    pauseCRMWhatsappNotificationDialogTimer(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber) {
      this.navigation.hoveredCRMWhatsappNotificationDialogs.add(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber);
      if (this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]) {
        clearTimeout(this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]);
        delete this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
      }
    },
    resumeCRMWhatsappNotificationDialogTimer(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber) {
      this.navigation.hoveredCRMWhatsappNotificationDialogs.delete(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber);
      if (!this.navigation.hoveredCRMWhatsappNotificationDialogs.has(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber)) {
        this.resetCRMWhatsappNotificationDialogTimers(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber);
      }
    },
    resetCRMWhatsappNotificationDialogTimers(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber) {
      if (this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]) {
        clearTimeout(this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]);
      }
      const dialog = this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
      if (!this.navigation.hoveredCRMWhatsappNotificationDialogs.has(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber) && dialog && !dialog.CRMWhatsappNotificationDialogPinned && !dialog.CRMWhatsappNotificationDialogReply) {
        this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber] = setTimeout(() => {
          if (!this.navigation.hoveredCRMWhatsappNotificationDialogs.has(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber) && dialog && !dialog.CRMWhatsappNotificationDialogPinned && !dialog.CRMWhatsappNotificationDialogReply) {
            delete this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
            delete this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
          }
        }, 5000);
      }
    },
    discardCRMWhatsappNotificationDialog(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber) {
      delete this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
      if (this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]) {
        clearTimeout(this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]);
        delete this.navigation.CRMWhatsappNotificationDialogTimers[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
      }
    },
    discardCRMWhatsappMessageNotificationDialog(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber, CRMWhatsappMessageNotificationDialogID) {
      const CRMWhatsappNotificationDialog = this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber];
      if (CRMWhatsappNotificationDialog) {
        const CRMWhatsappMessageNotificationDialog = CRMWhatsappNotificationDialog.CRMWhatsappMessages.find(CRMWhatsappMessage => CRMWhatsappMessage.CRMWhatsappMessageNotificationDialogID == CRMWhatsappMessageNotificationDialogID);
        if (CRMWhatsappMessageNotificationDialog) {
          CRMWhatsappMessageNotificationDialog.isRemoving = true;
          setTimeout(() => {
            CRMWhatsappNotificationDialog.CRMWhatsappMessages.splice(CRMWhatsappNotificationDialog.CRMWhatsappMessages.indexOf(CRMWhatsappMessageNotificationDialog), 1);
            if (CRMWhatsappNotificationDialog.CRMWhatsappMessages.length == 0) {
              this.discardCRMWhatsappNotificationDialog(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber);
            }
          }, 300);
        }
      }
    },

    showCRMWhatsappNotificationDialog(CRMWhatsappMessageNotificationDialogRequestQuery) {
      const CRMWhatsappMessageNotificationDialogID = Math.random().toString(36).substring(2, 15);
      const CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber = CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber;
      const newCRMWhatsappNotificationDialog = 
      {
        'CRMWhatsappMessageNotificationDialogID': CRMWhatsappMessageNotificationDialogID,
        'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID': CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID,
        'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageAPIID': CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageAPIID,
        'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType': CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType,
        'CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent': CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent,
        'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageDateTime': new Date()
      };
      if (!this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber]) {
        this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber] = 
        {
          'CRMWhatsappNotificationDialogCRMWhatsappConversationID': CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappConversationID,
          'CRMWhatsappNotificationDialogCRMWhatsappConversationPhoneNumber': CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber,
          'CRMWhatsappNotificationDialogCRMWhatsappContactName': CRMWhatsappMessageNotificationDialogRequestQuery.CRMWhatsappMessageNotificationDialogCRMWhatsappContactName,
          'CRMWhatsappNotificationDialogCollapsed': false,
          'CRMWhatsappNotificationDialogPinned': false,
          'CRMWhatsappNotificationDialogReply': false,
          'CRMWhatsappNotificationDialogReplyCRMWhatsappMessageContextCRMWhatsappMessageID': null,
          'CRMWhatsappNotificationDialogReplyText': null,
          'CRMWhatsappNotificationDialogReplyLoader': false,
          'CRMWhatsappMessages': []
        };
      }
      this.display.CRMWhatsappNotificationDialogs[CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber].CRMWhatsappMessages.unshift(newCRMWhatsappNotificationDialog);
      this.$generalFunctions.default.playSound('CRMWhatsappMessageNotification', this.systemInformationData.volumeLevel);
      this.resetCRMWhatsappNotificationDialogTimers(CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber);
    },



    pauseCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackDialogID) {
      this.navigation.hoveredCRMWhatsappConversationFeedbackDialogs.add(CRMWhatsappConversationFeedbackDialogID);
      if (this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID]) {
        clearTimeout(this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID]);
        delete this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID];
      }
    },
    resumeCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackDialogID) {
      this.navigation.hoveredCRMWhatsappConversationFeedbackDialogs.delete(CRMWhatsappConversationFeedbackDialogID);
      if (!this.navigation.hoveredCRMWhatsappConversationFeedbackDialogs.has(CRMWhatsappConversationFeedbackDialogID)) {
        this.resetCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackDialogID);
      }
    },
    discardCRMWhatsappConversationFeedbackDialog(CRMWhatsappConversationFeedbackDialogID) {
      delete this.display.CRMWhatsappConversationFeedbackDialogs[CRMWhatsappConversationFeedbackDialogID];
      if (this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID]) {
        clearTimeout(this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID]);
        delete this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID];
      }
    },
    resetCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackDialogID) {
      if (this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID]) {
        clearTimeout(this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID]);
      }
      const dialog = this.display.CRMWhatsappConversationFeedbackDialogs[CRMWhatsappConversationFeedbackDialogID];
      if (!this.navigation.hoveredCRMWhatsappConversationFeedbackDialogs.has(CRMWhatsappConversationFeedbackDialogID) && dialog && !dialog.CRMWhatsappConversationFeedbackDialogPinned && !dialog.CRMWhatsappConversationFeedbackDialogReply) {
        this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID] = setTimeout(() => {
          if (!this.navigation.hoveredCRMWhatsappConversationFeedbackDialogs.has(CRMWhatsappConversationFeedbackDialogID) && dialog && !dialog.CRMWhatsappConversationFeedbackDialogPinned && !dialog.CRMWhatsappConversationFeedbackDialogReply) {
            delete this.display.CRMWhatsappConversationFeedbackDialogs[CRMWhatsappConversationFeedbackDialogID];
            delete this.navigation.CRMWhatsappConversationFeedbackDialogTimers[CRMWhatsappConversationFeedbackDialogID];
          }
        }, 60000);
      }
    },

    showCRMWhatsappConversationFeedbackDialog(CRMWhatsappConversationFeedbackRequestQuery) {
      const CRMWhatsappConversationFeedbackDialogID = Math.random().toString(36).substring(2, 15);
      const newCRMWhatsappConversationFeedbackDialog = 
      {
        'CRMWhatsappConversationFeedbackDialogID': CRMWhatsappConversationFeedbackDialogID,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationID': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationID,
        'CRMWhatsappConversationFeedbackDialogCRMContactName': this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(CRMWhatsappConversationFeedbackRequestQuery),
        'CRMWhatsappConversationFeedbackDialogCRMContactPhoneNumber': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappContactPhoneNumber,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackOne': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationFeedbackOne,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackTwo': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationFeedbackTwo,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackThree': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationFeedbackThree,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackFour': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationFeedbackFour,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackSix': CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationFeedbackSix,
        'CRMWhatsappConversationFeedbackDialogCRMWhatsappConversationFeedbackDateTime': new Date()
      };
      this.display.CRMWhatsappConversationFeedbackDialogs[CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationID] = newCRMWhatsappConversationFeedbackDialog;
      this.resetCRMWhatsappConversationFeedbackDialogTimer(CRMWhatsappConversationFeedbackRequestQuery.CRMWhatsappConversationID);
    },

    pauseSystemNotificationDialogTimer(systemNotificationDialogID) {
      this.navigation.hoveredSystemNotificationDialogs.add(systemNotificationDialogID);
      if (this.display.systemNotificationDialogs[systemNotificationDialogID]) {
        clearTimeout(this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogTimer);
        delete this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogTimer;
      }
    },
    resumeSystemNotificationDialogTimer(systemNotificationDialogID) {
      this.navigation.hoveredSystemNotificationDialogs.delete(systemNotificationDialogID);
      if (!this.navigation.hoveredSystemNotificationDialogs.has(systemNotificationDialogID)) {
        this.resetSystemNotificationDialogTimer(systemNotificationDialogID);
      }
    },
    resetSystemNotificationDialogTimer(systemNotificationDialogID) {
      if (this.display.systemNotificationDialogs[systemNotificationDialogID]) {
        clearTimeout(this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogTimer);
        const dialog = this.display.systemNotificationDialogs[systemNotificationDialogID];
        if (!dialog.systemNotificationDialogPinned && !this.navigation.hoveredSystemNotificationDialogs.has(systemNotificationDialogID)) {
          dialog.systemNotificationDialogTimer = setTimeout(() => {
            this.discardNotificationDialog(systemNotificationDialogID);
          }, dialog.systemNotificationDialogType == 'CRMWhatsappConversationTransfer' ? 60000 : 5000);
        }
      }
    },
    discardNotificationDialog(systemNotificationDialogID) {
      if (this.display.systemNotificationDialogs[systemNotificationDialogID]) {
        clearTimeout(this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogTimer);
        delete this.display.systemNotificationDialogs[systemNotificationDialogID];
      }
    },
    showSystemNotificationDialog(systemNotificationDialogID, systemNotificationDialogType, systemNotificationDialogBody, systemNotificationDialogData, systemNotificationDialogPlaySound) {
      const newSystemNotificationDialog = 
      {
        'systemNotificationDialogID': systemNotificationDialogID,
        'systemNotificationDialogType': systemNotificationDialogType,
        'systemNotificationDialogBody': systemNotificationDialogBody,
        'systemNotificationDialogData': systemNotificationDialogData,
        'systemNotificationDialogOccurrences': 1,
        'systemNotificationDialogPinned': false,
        'systemNotificationDialogTimer': null,
        'systemNotificationDialogTriggerPlusOneAnimation': false
      };
      if (!this.display.systemNotificationDialogs[systemNotificationDialogID]) {
        this.display.systemNotificationDialogs[systemNotificationDialogID] = newSystemNotificationDialog;
      } else {
        void this.display.systemNotificationDialogs[systemNotificationDialogID].$el?.offsetHeight;
        this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogOccurrences++;
        this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogTriggerPlusOneAnimation = true;
        setTimeout(() => {
          if (this.display.systemNotificationDialogs[systemNotificationDialogID]) {
            this.display.systemNotificationDialogs[systemNotificationDialogID].systemNotificationDialogTriggerPlusOneAnimation = false;
          }
        }, 1000);
      }
      if (systemNotificationDialogType == 'error' && systemNotificationDialogPlaySound) this.$generalFunctions.default.playSound('errorSystemNotificationDialog', this.systemInformationData.volumeLevel);
      if (systemNotificationDialogType == 'success' && systemNotificationDialogPlaySound) this.$generalFunctions.default.playSound('successSystemNotificationDialog', this.systemInformationData.volumeLevel);
      if (systemNotificationDialogType == 'CRMWhatsappConversationTransfer' && systemNotificationDialogPlaySound) this.$generalFunctions.default.playSound('requestCRMWhatsappConversationTransfer', this.systemInformationData.volumeLevel);
      this.resetSystemNotificationDialogTimer(systemNotificationDialogID);
    },


    async acceptCRMWhatsappConversationTransfer(systemNotificationDialogID) {
      const systemNotificationDialog = this.display.systemNotificationDialogs[systemNotificationDialogID];
      if (systemNotificationDialog) {
        this.discardNotificationDialog(systemNotificationDialogID);
        const acceptCRMWhatsappConversationTransferRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'sourceCRMAgentID': systemNotificationDialog.systemNotificationDialogData.sourceCRMAgentID,
          'CRMWhatsappConversationID': systemNotificationDialog.systemNotificationDialogData.CRMWhatsappConversationID
        };
        const acceptCRMWhatsappConversationTransferResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/acceptCRMWhatsappConversationTransfer', acceptCRMWhatsappConversationTransferRequestQuery);
        if (acceptCRMWhatsappConversationTransferResult.success == false) {
          this.showSystemNotificationDialog('acceptCRMWhatsappConversationTransfer_error', 'error', 'Ha ocurrido un error inesperado al aceptar la transferencia de la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      }
    },

    async rejectCRMWhatsappConversationTransfer(systemNotificationDialogID) {
      const systemNotificationDialog = this.display.systemNotificationDialogs[systemNotificationDialogID];
      if (systemNotificationDialog) {
        this.discardNotificationDialog(systemNotificationDialogID);
        const rejectCRMWhatsappConversationTransferRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'sourceCRMAgentID': systemNotificationDialog.systemNotificationDialogData.sourceCRMAgentID,
          'CRMWhatsappConversationID': systemNotificationDialog.systemNotificationDialogData.CRMWhatsappConversationID
        };
        const rejectCRMWhatsappConversationTransferResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/rejectCRMWhatsappConversationTransfer', rejectCRMWhatsappConversationTransferRequestQuery);
        if (rejectCRMWhatsappConversationTransferResult.success == false) {
          this.showSystemNotificationDialog('rejectCRMWhatsappConversationTransfer_error', 'error', 'Ha ocurrido un error inesperado al rechazar la transferencia de la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      }
    },
    

    resetCRMRealTimeEventTimer(CRMRealTimeEventID) {
      if (this.display.CRMRealTimeEvents[CRMRealTimeEventID]) {
        clearTimeout(this.display.CRMRealTimeEvents[CRMRealTimeEventID].CRMRealTimeEventTimer);
        const event = this.display.CRMRealTimeEvents[CRMRealTimeEventID];
        if (!event.CRMRealTimeEventPinned && !this.navigation.hoveredCRMRealTimeEvents.has(CRMRealTimeEventID)) {
          event.CRMRealTimeEventTimer = setTimeout(() => {
            this.discardCRMRealTimeEvent(CRMRealTimeEventID);
          }, 5000);
        }
      }
    },
    pauseCRMRealTimeEventTimer(CRMRealTimeEventID) {
      this.navigation.hoveredCRMRealTimeEvents.add(CRMRealTimeEventID);
      if (this.display.CRMRealTimeEvents[CRMRealTimeEventID]) {
        clearTimeout(this.display.CRMRealTimeEvents[CRMRealTimeEventID].CRMRealTimeEventTimer);
        delete this.display.CRMRealTimeEvents[CRMRealTimeEventID].CRMRealTimeEventTimer;
      }
    },
    resumeCRMRealTimeEventTimer(CRMRealTimeEventID) {
      this.navigation.hoveredCRMRealTimeEvents.delete(CRMRealTimeEventID);
      if (!this.navigation.hoveredCRMRealTimeEvents.has(CRMRealTimeEventID)) {
        this.resetCRMRealTimeEventTimer(CRMRealTimeEventID);
      }
    },
    discardCRMRealTimeEvent(CRMRealTimeEventID) {
      if (this.display.CRMRealTimeEvents[CRMRealTimeEventID]) {
        clearTimeout(this.display.CRMRealTimeEvents[CRMRealTimeEventID].CRMRealTimeEventTimer);
        delete this.display.CRMRealTimeEvents[CRMRealTimeEventID];
      }
    },

    showCRMRealTimeEvent(CRMRealTimeEventID, CRMRealTimeEventType, CRMRealTimeEventData) {
      const newCRMRealTimeEvent = 
      {
        'CRMRealTimeEventID': CRMRealTimeEventID,
        'CRMRealTimeEventType': CRMRealTimeEventType,
        'CRMRealTimeEventData': CRMRealTimeEventData,
        'CRMRealTimeEventPinned': false
      };
      this.display.CRMRealTimeEvents[CRMRealTimeEventID] = newCRMRealTimeEvent;
      this.resetCRMRealTimeEventTimer(CRMRealTimeEventID);
    },
   


    async getSystemInformationData() {
      try {
        systemInformation.setGeneralFunctions(this.$generalFunctions.default);
        const systemInformationResult = await systemInformation.startup();
        if (systemInformationResult.success){
          this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
          this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
          this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
          this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
          this.systemInformationData.volumeLevel = systemInformation.getVolumeLevel;
          this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
        } else {
          this.showSystemNotificationDialog('CRMWhatsappNotificationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      } catch {
        this.showSystemNotificationDialog('CRMWhatsappNotificationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
      }
    },
    

  },

  async mounted() {
    await this.getSystemInformationData();
  },

  beforeUnmount() {
    if (this.systemInformationData.updateSubscription) {
      systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
    }
  },
}
</script>